<template>
    <form-group
            :name="name"
            :label="label"
            :help-text="helpText"
            :error="error"
            :label-width="labelWidth"
            :input-width="inputWidth"
            :button-width="buttonWidth"
            :button-text="buttonText"
            @click="$emit('click')"
    >
        <input
                type="text"
                :id="name"
                class="form-control"
                :placeholder="label"
                :value="value"
                :disabled="disabled"
                @input="$emit('input', $event.target.value)"
        >
    </form-group>
</template>

<script>
    import FormGroup from "@/components/FormGroups/Horizontal/FormGroupWithButton"

    export default {
        components: {FormGroup},

        props: {
            "name": {},
            "label": {},
            "helpText": {"default": null},
            "value": {},
            "error": {},
            "labelWidth": {},
            "inputWidth": {},
            "buttonWidth": {},
            "buttonText": {"default": '<i class="fa fa-plus"></i> Create'},
            "disabled": {"default": false}
        },
    }
</script>
